// import { Box } from "@material-ui/core";
import Box from '@mui/material/Box';
import { useHistory } from "react-router";
import BackgroundTheme from "../../../Common/P2P/Header/BackgroundTheme";
import KycExistsForm from "./KycExistsForm";

const KycExists = () => {
  const history = useHistory();
  const handleDashboard = () => {
    history.push("/p2p/dashboard");
  }
  
  return (
    <>
      <BackgroundTheme>
        <Box className="personalInfo">
          <KycExistsForm
            handleDashboard={handleDashboard}
          />
        </Box>
      </BackgroundTheme>
    </>
  );
};

export default KycExists;